import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from "vue";
import { ChartData, ChartOptions } from "chart.js/auto";
import Chart from "../../base-components/Chart";
import { getColor } from "../../utils/colors";
import {useStore} from "vuex";


export default /*#__PURE__*/_defineComponent({
  __name: 'SimpleLineChart1',
  props: {
    width: null,
    height: null,
    lineColor: null
  },
  setup(__props: any) {

const props = __props as {
  width?: number;
  height?: number;
  lineColor?: string;
}



const store = useStore();

const colorScheme = computed(() => store.getters.colorScheme);

const data = computed<ChartData>(() => {
  return {
    labels: [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ],
    datasets: [
      {
        label: "# of Votes",
        data: [0, 200, 250, 200, 500, 450, 850, 1050, 950, 1100, 900, 1200],
        borderWidth: 2,
        borderColor:
          colorScheme.value && props.lineColor?.length
            ? props.lineColor
            : getColor("primary", 0.8),
        backgroundColor: "transparent",
        pointBorderColor: "transparent",
        tension: 0.4,
      },
    ],
  };
});

const options = computed<ChartOptions>(() => {
  return {
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
    },
    scales: {
      x: {
        ticks: {
          display: false,
        },
        grid: {
          display: false,
          drawBorder: false,
        },
      },
      y: {
        ticks: {
          display: false,
        },
        grid: {
          display: false,
          drawBorder: false,
        },
      },
    },
  };
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Chart), {
    type: "line",
    width: props.width,
    height: props.height,
    data: _unref(data),
    options: _unref(options)
  }, null, 8, ["width", "height", "data", "options"]))
}
}

})